// Forms that submit to a PDF: legacy DOCBOX_INTERCEPT_FORMS, on by default
// (installFormSubmitInterceptor, public/docbox.js:36677-36737).
import { hasTemporaryAuth, looksLikePdfUrl } from "./links";

/**
 * The PDF URL a submit opens, or null when the host keeps the submit. The submitter's formaction
 * and formmethod win over the form's action and method. Only a GET submit to a URL that ends in
 * .pdf opens. The form fields are added to the URL's query, after any query it already has
 * (docbox.js:36697-36731). The submitter's own name and value are not added, as in legacy.
 */
export function pdfSubmitUrl(
  form: HTMLFormElement,
  submitter: Element | null,
): string | null {
  const doc = form.ownerDocument;
  let action = submitter?.getAttribute("formaction") || "";
  let method = submitter?.getAttribute("formmethod") || "";
  // form.action and form.method are the reflected values. A field named "action" or "method"
  // hides them, and then only the attribute counts.
  if (!action) action = form.getAttribute("action") || stringOr(form.action);
  if (!method) method = form.getAttribute("method") || stringOr(form.method);
  // Legacy can only rebuild a GET submit as a URL (docbox.js:36712).
  if ((method || "get").toLowerCase() !== "get") return null;
  let url: URL;
  try {
    url = new URL(action, doc.baseURI);
  } catch {
    return null;
  }
  if (!looksLikePdfUrl(url.href) && !looksLikePdfUrl(action)) return null;
  new FormData(form).forEach((value, key) => {
    if (key)
      url.searchParams.append(key, typeof value === "string" ? value : "");
  });
  return hasTemporaryAuth(url.href) ? null : url.href;
}

function stringOr(value: unknown): string {
  return typeof value === "string" ? value : "";
}
